/**
 * The research-topic subnav, declared on the route (`handle.subnav`) so it reaches the band without
 * going through the redux header (APP-3564).
 */

import { useCallback } from "react"
import { useParams } from "react-router-dom"
import Subnav from "components/research-topic-sub-nav"
import { useAppDispatch, useAppSelector } from "hooks/redux"
import { getRefInstrumentResource } from "modules/research-topic/helpers"
import { Creators } from "./model"
import { getCurrentTopic, getModel, getModels, getPortfolioDates } from "./selectors"

export default function ResearchTopicSubnav() {
  const params = useParams()
  const dispatch = useAppDispatch()
  const topic = useAppSelector(state => getCurrentTopic(state, { params }))
  const models = useAppSelector(getModels)
  const modelId = useAppSelector(getModel)
  const portfolioDates = useAppSelector(getPortfolioDates)

  const setModel = useCallback((id: string) => dispatch(Creators.setModel(id)), [dispatch])

  // Gate on the CURRENT topic, not just the model: without it `getRefInstrumentResource` yields an
  // empty resource. The empty band holds the row's height rather than collapsing it.
  if (!topic || !modelId) { return <div className="research-topic-root-subnav" /> }

  const { id: resourceId, type } = getRefInstrumentResource(topic)
  // `getRefInstrumentResource` lowercases an untyped field; narrow it to the prop's union.
  const resourceType = type === "portfolio" ? "portfolio" : "security"

  return <Subnav
    modelId={modelId}
    models={models}
    setModel={setModel}
    resourceId={resourceId}
    resourceType={resourceType}
    portfolioDates={portfolioDates}
  />
}
